import axiosInstance from "../../api/axiosInstance";

export const loginAPI = async (credentials) => {
  const response = await axiosInstance.post("admins/admin-login", credentials);
  return response.data;
};

export const logoutAPI = async () => {
  const refreshToken = localStorage.getItem("refreshToken");

  if (refreshToken) {
    try {
      await axiosInstance.post("auth/logout", { refreshToken });
    } catch {
      // Best-effort: even if the call fails, we still clear local state
    }
  }

  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("adminId");
  localStorage.removeItem("adminName");
};

export const getAdminRolePermissionAPI = async (adminId) => {
  const response = await axiosInstance.get(
    `admins/find-admin-role-permissions-by-id/${adminId}`,
  );
  return response.data;
};
